import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  getIframe,
  setAddEventListener,
  setBottomSheet,
  setConfirmModal,
  stringToHTML,
} from '../../helpers';
import { setAlertModal, showAlertModal } from '../components/alert';

const ChargDepositAuto = {
  // 코드 리스트
  // MIN_SAFE_AMT_CODE limit
  // CHAR_UNIT_AMT_CODE money

  // Constant
  charg: {
    limit: '',
    money: '',
  },
  limitList: [],
  moneyList: [],

  render: async () => {
    setAlertModal();

    try {
      const msg = '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
      const minSafeAmt = await getApv('common/code?grpCode=MIN_SAFE_AMT_CODE');
      if (minSafeAmt == null) throw msg;
      const charUnit = await getApv('common/code?grpCode=CHAR_UNIT_AMT_CODE');
      if (charUnit == null) throw msg;

      ChargDepositAuto.moneyList = minSafeAmt;
      ChargDepositAuto.limitList = charUnit;
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
    }

    ChargDepositAuto.moneyList.sort((a, b) => {
      return a.codeId - b.codeId;
    });
    ChargDepositAuto.limitList.sort((a, b) => {
      return a.codeId - b.codeId;
    });

    const initialData = await getApv('charging/autoChargeInfo');

    ChargDepositAuto.charg.limit = initialData?.minSafeAmt ?? 0;
    ChargDepositAuto.charg.money = initialData?.chrgUnitAmt ?? 0;

    // 코드는 스트링 , 내려주는 값은 int
    let limitLabel = '선택해주세요';
    for (const item of ChargDepositAuto.limitList) {
      if (item.codeId == ChargDepositAuto.charg.limit) {
        limitLabel = `${item.codeName} 미만이 되면`;
        break;
      }
    }

    // 코드는 스트링 , 내려주는 값은 int
    let moneyLabel = '선택해주세요';
    for (const item of ChargDepositAuto.moneyList) {
      if (item.codeId == ChargDepositAuto.charg.money) {
        moneyLabel = `${item.codeName}을 충전합니다`;
        break;
      }
    }

    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
        <div class="c_title1">충전머니 자동충전</div>
        <div class="form-group m_b_20">
            <label class="c_label1">충전머니 잔액이</label>
            <div class="c_bod1 c_box skin1_bod" id="charg_method_limit">
                <div class="c_label4_3" id="charg_deposit_limit_label">${limitLabel}</div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
            </div>
            <div class="c_bod1 c_box skin1_bod m_t_10" id="charg_method_money">
                <div class="c_label4_3" id="charg_deposit_money_label">${moneyLabel}</div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
            </div>
        </div>
        <div class="m_t_10">
            <span class="c_label5_1">
            - 충전머니 사용 후 조건이 충족되면 주계좌에서 자동충전됩니다.
            </span>
        </div>

        <div class="c_box bottom_btn_wrapper" id="charge_deposit_auto_bottom" />
    `;
  },
  afterRender: async () => {
    // setAlertModal
    setAlertModal();

    // HTML
    const chargeMethodLimitContentModalLayer = `
    <div class="modal c_btm1" id="charg_method_limit_content">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">기준금액</h5>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="charg_method_limit_list"/>
            </div>
        </div>
    </div>
    `;

    const chargeMethodMoneyContentModalLayer = `
    <div class="modal c_btm1" id="charg_method_money_content">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">충전금액</h5>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="charg_method_money_list"/>
            </div>
        </div>
    </div>
    `;

    // Functions
    const setChargeInfo = (data, flag) => {
      postApv('charging/setAutoCharge', data)
        .then((res) => {
          showAlertModal(
            '알림',
            `충전머니 자동충전 정보를 ${flag ? '저장' : '삭제'} 했습니다.`,
            () => {
              history.back();
            }
          );
        })
        .catch((err) => {
          showAlertModal('오류', err.resultMessage);
          console.error(err);
        });
    };

    const onClickLimit = (item) => {
      getIframe().getElementById(
        'charg_deposit_limit_label'
      ).innerText = `${item.innerText}이 되면`;
      ChargDepositAuto.charg.limit = item.getAttribute('value');
      getIframe()
        .querySelectorAll('#charg_method_limit_list > div')
        .forEach((element) => {
          element.className =
            element.id === 'limit' + ChargDepositAuto.charg.limit
              ? 'item c_label6'
              : 'item c_label6_1';
        });
      closeBottomSheet('charg_method_limit');
    };
    const onClickMoney = (item) => {
      getIframe().getElementById(
        'charg_deposit_money_label'
      ).innerText = `${item.innerText}을 충전합니다`;
      ChargDepositAuto.charg.money = item.getAttribute('value');
      getIframe()
        .querySelectorAll('#charg_method_money_list > div')
        .forEach((element) => {
          element.className =
            element.id === 'money' + ChargDepositAuto.charg.money
              ? 'item c_label6'
              : 'item c_label6_1';
        });
      closeBottomSheet('charg_method_money');
    };
    const onClickConfirm = () => {
      const data = {
        minSafeAmt: ChargDepositAuto.charg.limit,
        chrgUnitAmt: ChargDepositAuto.charg.money,
      };
      setChargeInfo(data, true);
    };
    const onClickDelete = () => {
      const data = {
        minSafeAmt: '0',
        chrgUnitAmt: '0',
      };
      setChargeInfo(data, false);
    };

    //View Draw Functions
    const drawLimitBottomSheet = () => {
      stringToHTML(chargeMethodLimitContentModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
      ChargDepositAuto.limitList.forEach((item) => {
        if (ChargDepositAuto.charg.limit === '') {
          getIframe().getElementById('charg_deposit_limit_label').innerText =
            '선택해주세요.';
        }
        getIframe().getElementById(
          'charg_method_limit_list'
        ).innerHTML += `<div class="${
          item.codeId === ChargDepositAuto.charg.limit
            ? 'item c_label6'
            : 'item c_label6_1'
        }"
                                    value="${item.codeId}"
                                    id="${'limit' + item.codeId}">${
          item.codeName + ' 미만'
        }</div>`;
      });

      setBottomSheet('charg_method_limit');
    };
    const drawMoneyBottomSheet = () => {
      stringToHTML(chargeMethodMoneyContentModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
      if (ChargDepositAuto.charg.money === '') {
        getIframe().getElementById('charg_deposit_money_label').innerText =
          '선택해주세요.';
      }
      ChargDepositAuto.moneyList.forEach((item) => {
        getIframe().getElementById(
          'charg_method_money_list'
        ).innerHTML += `<div class="${
          item.codeId === ChargDepositAuto.charg.money
            ? 'item c_label6'
            : 'item c_label6_1'
        }"
                                    value="${item.codeId}"
                                    id="${'money' + item.codeId}">${
          item.codeName
        }</div>`;
      });
      setBottomSheet('charg_method_money');
    };

    const drawBottomButton = () => {
      let classString = 'btn c_btn1 skin1_btn';
      if (
        ChargDepositAuto.charg.money !== '' &&
        ChargDepositAuto.charg.limit !== ''
      ) {
        classString = 'btn c_btn4 skin1_btn2';
        getIframe().getElementById(
          'charge_deposit_auto_bottom'
        ).innerHTML += `<button type="button" class="btn c_btn3 skin1_btn1" id="charge_deposit_auto_delete">삭제</button>`;
      }

      getIframe().getElementById(
        'charge_deposit_auto_bottom'
      ).innerHTML += `<button type="button" id="charge_deposit_auto_confirm" class="${classString}">저장</button>`;
    };

    //View Draw
    drawLimitBottomSheet();
    drawMoneyBottomSheet();
    drawBottomButton();

    // SetEvents
    setAddEventListener('connect_pay_back_button', () => history.back());

    // modal set - confirm
    setConfirmModal(
      'charge_deposit_auto_confirm',
      'confirm_modal_layer_id',
      () => {
        history.back();
      }
    );
    // modal set - delete
    setConfirmModal(
      'charge_deposit_auto_delete',
      'confirm_modal_layer_id',
      () => {
        history.back();
      }
    );

    setAddEventListener('charge_deposit_auto_confirm', () => {
      onClickConfirm();
    });
    if (
      ChargDepositAuto.charg.money !== '' &&
      ChargDepositAuto.charg.limit !== ''
    ) {
      setAddEventListener('charge_deposit_auto_delete', () => {
        onClickDelete();
      });
    }
    getIframe()
      .querySelectorAll('#charg_method_limit_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          onClickLimit(element);
        });
      });
    getIframe()
      .querySelectorAll('#charg_method_money_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          onClickMoney(element);
        });
      });
  },
};
export default ChargDepositAuto;
